import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from "../../services/configuration/configuration.service";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { RoutingValidationService } from "../../services/routingValidation/routing-validation.service";
import { LoginService } from "../../services/login/login.service";
import { TokenControlService } from "../../services/state/tokenControl.service";
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { StateService } from "../../services/state/state.service";
import { State } from '../../model/state';
import { OfflineService } from '../../services/data/offline.service';
import { CONFIG } from '../../constants/constants';

declare var $: any;

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css'],
  providers: [ LoginService, ConfigurationService]
})
export class TermsComponent implements OnInit {

  //Flag que indica si hay conexion a internet o no
  public online: boolean;

  /** Almacena los terminos y condiciones */
  public terms: string;

  /** Representa obligatoriedad de los terminos */
  public condicionalTerminos: string;

  /** flag para mostrar videos insor */
  public showINSOR: Boolean;

  constructor(private _translateService: TranslateService,
    private _loginService: LoginService,
    private _tokenController: TokenControlService,
    private _configurationControlService: ConfigurationControlService,
    private _configurationService: ConfigurationService,
    private _routingValidationService: RoutingValidationService,
    private _offlineService: OfflineService,
    private _stateService: StateService) {

    this._translateService.addLangs(["es", "en"]);
    this._translateService.setDefaultLang("es");
    this._translateService.use("es");
    this.condicionalTerminos = "";
    if (this._configurationControlService.examConfiguration.tourTest == "INSOR") {
      this.showINSOR = true;
    } else {
      this.showINSOR = false;
    }
  }

  ngOnInit() {
    let self = this;
    this._configurationService.inhabilitarBotonAtras();
    let array = this._configurationControlService.examConfiguration.showTerms.split("vvvvv");
    this.condicionalTerminos = array[0];
    this.terms = array[1];
    if (this.condicionalTerminos == 'NINGUNO') {
      this._configurationControlService.examConfiguration.showTerms = null;
      this._routingValidationService.validateRouting("termsToTour");
    } 
    if (this.showINSOR) {
      self.showINSOR = true;
      setTimeout(function () {       
        $("#termsINSOR").html(self.terms);
      }, 200);
    } else {
      setTimeout(function () {
        $("#terms").html(self.terms);
        $("#contenedor").css("width", "650px");
      }, 200);
      
    }

  }

  /** Metodo encargado de redireccionar a la prueba */
  public aceptar(action: string) {
    
    let estado = 0;
    switch (action) {
      case 'confirmar':
        estado = ESTADO_SESSION_INFO.ACEPTAR_TERMINO;
        break;
      case 'denegar':
        estado = ESTADO_SESSION_INFO.NO_ACEPTO_TERMINO;
        break;
    }
    if(CONFIG.ONLINE == false){
      this._stateService.state = new State(1,this._tokenController.token.sesion , 1, this._offlineService.credential.idCredencial);
    }
    this._configurationControlService.sessionInfo.sesion = this._stateService.state.sesion
    this._configurationControlService.sessionInfo.estado = estado;
    this._loginService.saveSessionInfo(this._tokenController.getTokenValue(), this._tokenController.token.tokenId, estado);
    this._configurationControlService.examConfiguration.showTerms = null;
    this._configurationControlService.sessionEventPile.push({...this._configurationControlService.sessionInfo, estado});
    this._routingValidationService.validateRouting("termsToTour");
  }

  /** encargado de cargar la info de la pantalla */
  public loadInfo() {
    let self = this;
    if (this.showINSOR) {
      self.showINSOR = true;
      setTimeout(function () {
        $("#termsINSOR").html(self.terms);
      }, 200);
    } else {
      setTimeout(function () {
        $("#terms").html(self.terms);
        $("#contenedor").css("width", "650px");
      }, 200);

    }
  }

}
